<div
  class="container {{ variant() }}"
  [class.show-animation]="showAnimation()"
  [class.close-animation]="closeAnimation()"
>
  <div
    #dialogElement
    class="dialog {{ color() }} size-{{ size() }}"
    [class.empty]="loading() || error()"
  >
    @if (loading()) {
      @if (showLoading()) {
        <onyx-spinner [size]="48"></onyx-spinner>
      }
    } @else if (error()) {
      <onyx-loading-error [(error)]="error"></onyx-loading-error>
    } @else {
      @if (showTopBar()) {
        @let headingMessage = heading() ?? '' | translate;
        <div class="top-bar" [class.sticky]="isHeaderSticky()">
          @if (isCenter()) {
            <ng-content select="[heading]"></ng-content>

            <div class="heading-icon">
              <ng-content select="[headingIcon]"></ng-content>
            </div>

            <h2>{{ headingMessage }}</h2>

            @if (headingTooltip(); as tooltip) {
              <div class="heading-icon">
                <onyx-tooltip [tooltip]="tooltip"></onyx-tooltip>
              </div>
            }

            <ng-container
              *ngTemplateOutlet="
                closeButtonTemplate;
                context: { type: 'absolute-variant' }
              "
            ></ng-container>
          } @else {
            <ng-content select="[image]"></ng-content>

            <div class="wrapper" [style.gap.px]="gap()">
              <div class="heading">
                <div class="title">
                  <ng-content select="[titleLeftOptions]"></ng-content>

                  <h3>{{ headingMessage }}</h3>

                  @if (count() != null) {
                    <h5 class="f-muted">{{ count() | number }}</h5>
                  }

                  <div class="right-options">
                    <ng-content select="[titleRightOptions]"></ng-content>
                  </div>
                </div>

                <div class="buttons-container">
                  <div class="buttons">
                    <ng-content select="[headingButtons]"></ng-content>
                  </div>

                  <ng-container
                    *ngTemplateOutlet="
                      closeButtonTemplate;
                      context: { type: 'static-variant' }
                    "
                  ></ng-container>
                </div>
              </div>

              <div class="description" #descriptionElement>
                <ng-content select="[description]"></ng-content>
              </div>
            </div>

            <div class="section-chips">
              <ng-content select="[sectionChips]"></ng-content>
            </div>
          }
        </div>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            closeButtonTemplate;
            context: { type: 'standalone-variant' }
          "
        ></ng-container>
      }

      <div
        class="content"
        [class.center]="isCenter()"
        [class.scrollbar-gutter]="!isCenter() && scrollbarGutter()"
        [class.fit]="fitContent()"
        (scroll)="handleContentScroll(content)"
        #content
      >
        <ng-content></ng-content>
      </div>

      <ng-content select="[bottomContent]"></ng-content>

      @if (showBottomBar() == null ? isCenter() : showBottomBar()) {
        <div class="bottom-bar" [class.sticky]="isFooterSticky()">
          <div class="group">
            <ng-content select="[bottomLeftOptions]"></ng-content>
          </div>

          <div class="group">
            <ng-content select="[bottomRightOptions]"></ng-content>
          </div>

          <ng-content select="[bottomBar]"></ng-content>
        </div>
      }
    }
  </div>
</div>

<ng-template let-type="type" #closeButtonTemplate>
  @if (showClose()) {
    <div class="internal-close-button" [class]="type">
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="close-outlined"
        [circle]="!isCenter()"
        [tabindex]="-1"
        [onyxTooltip]="`${I18N}.close`"
        (click)="closeDialog()"
      ></onyx-icon-button>
    </div>
  }
</ng-template>
